module.exports = __webpack_public_path__ + "img/slide5_img6.6c21a257.png";